<template>
    <div class="align-c label-detail single">
        <p class="label-focus" v-if="ASSETS.PriorityType.Focused(this) && showPriorityTypeLabel">Focus</p>
        <p class="date-range">
            <span v-if="ASSETS.PriorityType.Focused(this)">as of</span> <span v-html="ASSETS.PriorityType.DateRange(this, priority.DateRange)"></span>
        </p>
    </div>
</template>

<script>
import { ASSETS } from "@/assets/JS/Assets.js";

export default {
    name: "PriorityTypeDateRange",
    props: {
        priority: Object,
        showPriorityTypeLabel: Boolean
    },
    data: () => ({ ASSETS })
};
</script>